<template>
  <div class="customer_home">
    <div class="main_table">
      <div class="Item__btn_container" v-if='accessRight3' >
        <div class="search_item">
          <svg class="icon" style="margin-right:8px" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M22.8184 21.9373L17.4468 16.5678C18.8966 14.9157 19.7777 12.7519 19.7777 10.3857C19.7777 5.21029 15.5653 1 10.3888 1C5.21133 0.998962 1 5.21029 1 10.3847C1 15.5591 5.21237 19.7704 10.3888 19.7704C12.7519 19.7704 14.9136 18.8924 16.5657 17.4468L21.9383 22.8174C22.0598 22.9398 22.2196 23 22.3784 23C22.5382 23 22.697 22.9388 22.8184 22.8174C23.0623 22.5745 23.0623 22.1802 22.8184 21.9373ZM10.3889 18.5251C5.89836 18.5251 2.24536 14.8731 2.24536 10.3847C2.24536 5.89626 5.89836 2.24429 10.3889 2.24429C14.8794 2.24429 18.5324 5.89626 18.5324 10.3847C18.5324 14.8731 14.8794 18.5251 10.3889 18.5251Z" fill="gray"/>
          </svg>
          <div ><input type="text" class="input_select" placeholder="Search item Security SN" v-model='searchItem'></div>
        </div>
        <md-button class="md-raised md-primary btn_customer" @click="showAdd"> <md-icon class="md-size-2x">add</md-icon>Add Item</md-button>
      </div>
      <md-table v-model="currentSiteItems" md-card style="max-height:750px">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="Logo" md-image><img :src="item.img_url" alt="avatar" v-if="item.img_url" style="background-color:white"></md-table-cell>
          <!-- <md-table-cell  md-label="Item Name" >{{ item.name }}</md-table-cell> -->
          <!-- <md-table-cell  md-label="Part Number " >{{ item.partNumber }}</md-table-cell> -->
          <!-- <md-table-cell md-label="Serial Number" >{{ item.serialNumber }}</md-table-cell> -->
          <md-table-cell md-label="Security SN" >{{ item.secureSN }}</md-table-cell>
          <md-table-cell md-label="Expired date" >{{ item.expiredDate }}</md-table-cell>
          <md-table-cell md-label="Bin" >{{ item.bin?item.shelfName +'-'+item.bin.deviceId:'NA' }}</md-table-cell>
           <md-table-cell md-label="Tag Number" >{{ item.bin?item.bin.tag:'NA' }}</md-table-cell>
          <md-table-cell md-label="Remark"  >{{ item.description }}</md-table-cell>
          <md-table-cell md-label="Status"  ><div :style="{color:item.active?'green':'red'}">{{item.active ? 'Active' : 'Inactive'}}</div></md-table-cell>
          <md-table-cell md-label="Edit"  v-if='accessRight3'>
              <md-menu md-size="medium" md-align-trigger>
              <md-button md-menu-trigger><md-icon>more_horiz</md-icon></md-button>
              <md-menu-content>
                  <md-menu-item @click="showUpdate(item)">Update</md-menu-item>
                  <md-menu-item @click="showDelete(item)"><div style="color:red">Delete</div></md-menu-item>
              </md-menu-content>
              </md-menu>
          </md-table-cell>
          </md-table-row>
      </md-table>
    </div>
     <Pagination  class="table_pagination" v-if='pagiShow'
          v-model="currentPage" 
          :page-count="totalPages"
          @change="onChange"
      />
    <md-dialog :md-active.sync="delete_active" class="custom_dialog_container">
        <md-dialog-title >
          <label class='lb_close' @click="delete_active=false"><md-icon class="icon_close">clear</md-icon></label>
          <label class='lb-title'>Delete Item</label>
        </md-dialog-title>
        <md-dialog-content>
          <span>Do you want to delete this item?</span>
          <br>
          <span>All related data will also be deleted.</span>
        </md-dialog-content>
        <md-dialog-actions>
          <md-button class="md-raised" @click="delete_active = false">Cancel</md-button>
          <md-button class="md-raised md-accent" @click="handleDeleteItem">Delete</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="update_active" class="dialog_updateSite custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close' @click="update_active=false;list_bin_show=false;bin_selected={}"><md-icon class="icon_close">clear</md-icon></label>
        <label class='lb-title'>Update Item</label>
      </md-dialog-title>
      <md-dialog-content>
      <form class="dialog_update__texts" ref="updateItemForm">
        <div class='logo_container' >
          <label>Logo</label>
          <div class="image_logo">
            <div class="image" :style="`background-image: url(${tempItem.img_url});`"><md-icon style="color:#D7D7D7;" v-if="!tempItem.img_url">camera_alt</md-icon></div>
            <label style="margin-right:20px">
              <input type="file" @change="addItemChangeLogo"/> Add logo
            </label>
          </div>
        </div>
        <!-- <div class="custom_input" >
          <input type="text"  placeholder="Item Name" v-model="tempItem.name" required>
          <label>Item Name*</label>
        </div>

        <div class="multi_input">
          <div class="custom_input" style="width:48%">
            <input type="text" placeholder="Part Number" v-model="tempItem.partNumber" required>
            <label>Part Number*</label>
          </div>

          <div class="custom_input" style="width:48%">
            <input type="text" placeholder="Serial Number*" v-model="tempItem.serialNumber" required>
            <label>Serial Number*</label>
          </div>
        </div> -->

        <div class="multi_input">
          <div class="custom_input" style="width:48%">
            <input type="text" placeholder="Secure SN*" v-model="tempItem.secureSN" required>
            <label>Security SN*</label>
          </div>

          <div class="custom_input" style="width:48%">
            <input type="text"  placeholder="Expired date" v-model="tempItem.expiredDate" >
            <label>Expired date</label>
          </div>
        </div>


        <!-- <div class="custom_input">
          <input type="text"  placeholder="Expired date" v-model="tempItem.expiredDate" >
          <label>Expired date</label>
        </div> -->
        <div class="custom_input">
          <input type="text"  placeholder="Remark" v-model="tempItem.description">
          <label>Remark</label>
        </div>
        
        <div style="margin-top:20px">
          <label >Status</label>
          <div class="margin-top:20px">
            <md-radio v-model="tempItem.active" class="md-primary" :value="true">Active</md-radio>
            <md-radio v-model="tempItem.active" class="md-primary" :value="false">Inactive</md-radio>
          </div>
        </div>
      </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-raised" @click="update_active = false;list_bin_show=false;bin_selected={}">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="handleUpdateItem">Save</md-button>
      </md-dialog-actions>
    </md-dialog>


    <md-dialog :md-active.sync="add_active" class="dialog_updateSite custom_dialog_container">
      <md-dialog-title >
        <label class='lb_close' @click="add_active=false;list_bin_show=false;bin_selected={}"><md-icon class="icon_close">clear</md-icon></label>
        <label class='lb-title'>Add Item</label>
      </md-dialog-title>
      <md-dialog-content>
      <form class="dialog_update__texts" ref="addItemForm">
        <div class='logo_container' >
          <label>Logo</label>
          <div class="image_logo">
            <img :src="tempItem.img_url" v-if="tempItem.img_url" alt="logo">
            <label style="margin-right:20px">
              <input type="file" @change="addItemChangeLogo"/> Add logo
            </label>
          </div>
        </div>
        <!-- <div class="custom_input" >
          <input type="text"  placeholder="Item Name" v-model="tempItem.name" required>
          <label>Item Name*</label>
        </div>
        <div class="multi_input">
          <div class="custom_input" style="width:48%">
            <input type="text" placeholder=" Part Number" v-model="tempItem.partNumber" required>
            <label>Part Number*</label>
          </div>

          <div class="custom_input" style="width:48%">
            <input type="text" placeholder="Serial Number" v-model="tempItem.serialNumber" required>
            <label>Serial Number*</label>
          </div>
        </div> -->
        
        <div class="multi_input">
          <div class="custom_input" style="width:48%">
            <input type="text" placeholder="Secure SN*" v-model="tempItem.secureSN" required>
            <label>Security SN*</label>
          </div>

          <div class="custom_input" style="width:48%">
            <input type="text"  placeholder="Expired date" v-model="tempItem.expiredDate" >
            <label>Expired date</label>
          </div>
        </div>
        <div class="custom_input">
          <input type="text"  placeholder="Remark" v-model="tempItem.description">
          <label>Remark</label>
        </div>

        <!-- <div class="dialog_update__selects">
          <div class="dialog_update__select">
            <div class="system_lists" v-if="list_bin_show">
              <li v-for="(item,index) in currentSiteBins" :key="index" @click="selectBin(item)">
                <div >{{item._name}}</div>
              </li>
            </div>
            <md-icon class="icon">keyboard_arrow_down</md-icon>
            <div @click="list_bin_show=!list_bin_show"><input type="text" class="input_select" placeholder="Bin" readonly v-model="bin_selected._name"></div>
            <label :style="{color:list_bin_show?'#0080F6':'#6D6E71'}">
              Bin
            </label>
          </div>
        </div> -->
        <div style="margin-top:20px">
          <label >Status</label>
          <div class="margin-top:20px">
            <md-radio v-model="tempItem.active" class="md-primary" :value="true">Active</md-radio>
            <md-radio v-model="tempItem.active" class="md-primary" :value="false">Inactive</md-radio>
          </div>
        </div>
      </form>
      </md-dialog-content>
    
      <md-dialog-actions>
        <md-button class="md-raised" @click="add_active = false;list_bin_show=false;bin_selected={}">Cancel</md-button>
        <md-button class="md-raised md-primary" @click="handleAddItem">Add</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import request from '@/utils/request'
import Pagination from '../../components/Pagination'
import resize from '@/utils/resize'
import {SERVER_HOSTNAME} from '../../utils/config'
export default {
  name:'SiteItem',
  components:{
    Pagination
  },
  created() {
    request('get', `/items/${this.currentPage}/?site=${this.siteId}`)
      .then(data => {
        this.items = data.items.map(el=>{
          if(el.img_url&&el.img_url.length>4){
            return {...el,img_url:SERVER_HOSTNAME+el.img_url}
          }
          return el
          
        })
        this.totalPages=data.pages
      })
      .catch(err => console.log(err))
    // request('post', `/bins/mini?site=${this.siteId}`,{mes:1})
    //   .then(data => {
    //     this.bins = data.bins.map(el=>{
    //       return{...el,_name:el.shelf?el.name+' of shelf '+el.shelf.name:el.name}
    //     })
    //   })
    //   .catch(err => console.log(err))
  },
  data(){
    return{
      currentPage: 1,
      totalPages:0,
      siteId: this.$route.params.id,
      update_active:false,
      delete_active:false,
      add_active:false,
      list_status_show:false,
      list_bin_show:false,
      status_selected:'',
      bin_selected: {},
      items: [],
      bins:[],
      tempItem: {},
      searchItem:'',
      changeLogo:false


    }
  },
  computed: {
    pagiShow() {
      if(this.totalPages>0) {
          return true;
      }
      return false;
    },
    currentSiteItems() {
      return this.items.filter(item => {
        return item.site && (item.site == this.siteId || item.site._id == this.siteId)
      })
    },
    currentSiteBins() {
      return this.bins.filter(bin => {
        return bin.site && (bin.site == this.siteId || bin.site._id == this.siteId) && bin.shelf
      })
    },
    accessRight3(){
      let roleRight=['ROOT','CUSTOMER','MASTER','OPERATOR','CONTRACTOR'];
      return roleRight.includes(this.$store.state.role)
    },
  },
  watch:{
    searchItem:function(){
      if(this.searchItem.length>=3){
        this.currentPage=1;
        request('post', `/items/search/${this.currentPage}`,{query:this.searchItem,site:this.siteId})
        .then(data => {
          this.items = data.items.map(el=>{
            if(el.img_url&&el.img_url.length>4){
              return {...el,img_url:SERVER_HOSTNAME+el.img_url}
            }
            return el
          
          })
          this.totalPages=data.pages
        })
        .catch(err => console.log(err))
      }
      else if(this.searchItem.length===0){
        this.currentPage=1
        request('get', `/items/${this.currentPage}/?site=${this.siteId}`)
        .then(data => {
          this.items = data.items.map(el=>{
            if(el.img_url&&el.img_url.length>4){
              return {...el,img_url:SERVER_HOSTNAME+el.img_url}
            }
            return el
          
          })
          this.totalPages=data.pages
        })
        .catch(err => console.log(err))
      }
    }

  },
  methods:{
    onChange: function () {
      if(this.searchItem.length==0){
        request('get',  `/items/${this.currentPage}?site=${this.siteId}`)
        .then(data => {
          this.items = data.items.map(el=>{
            if(el.img_url&&el.img_url.length>4){
              return {...el,img_url:SERVER_HOSTNAME+el.img_url}
            }
            return el
          
          })
          this.totalPages=data.pages;
        })
        .catch(err => console.log(err))
      }
      else{
        request('post', `/items/search/${this.currentPage}`,{query:this.searchItem,site:this.siteId})
        .then(data => {
          this.items = data.items.map(el=>{
            if(el.img_url&&el.img_url.length>4){
              return {...el,img_url:SERVER_HOSTNAME+el.img_url}
            }
            return el
          
          })
          this.totalPages=data.pages
        })
        .catch(err => console.log(err))
      }
       
    },
    addItemChangeLogo(e){
      let file = e.target.files[0]

      if(file.type.match(/image.*/)) {
        resize(file)
          .then(dataUrl => {
            this.tempItem.img_url = dataUrl
            console.log(this.tempItem)
            this.changeLogo=true
          })
      }
      else{
        alert('Please choose a image!')
      }
    },
    showAdd() {
      this.tempItem = {
        name: '',
        description: '',
        partNumber: '',
        capacity: 0,
        bin: null,
        site: null,
        active: true,
        img_url:''
      }
      this.add_active=true
    },
    showUpdate(el){
      this.tempItem = {
        ...el
      }
      // console.log(el)

      // this.bin_selected = {}
      // if (el.bin && el.bin._id) {
        
      //   for (let i = 0; i < this.bins.length; i++) {
      //     if (this.bins[i]._id == el.bin._id) {
      //       this.bin_selected = this.bins[i]
      //       break
      //     }
      //   }
      // }
      // } else {
      //   for (let i = 0; i < this.bins.length; i++) {
      //     if (this.bins[i]._id == el.bin) {
      //       this.bin_selected = this.bins[i]
      //       break
      //     }
      //   }
      // }
      
     
      this.update_active=true;
    },
    showDelete(el){
      this.tempItem = el
      this.delete_active=true;
    },
    handleDeleteItem(){
      request('delete', `/items/${this.tempItem._id}`, {site: this.tempItem.site})
      .then(() => {
        if(this.items.length===1 && this.currentPage>1)
        {
          this.currentPage=this.currentPage-1;
        }
        return request('get',  `/items/${this.currentPage}?site=${this.siteId}`)
      })
      .then(data => {
        this.delete_active=false;
        this.items = data.items.map(el=>{
          if(el.img_url&&el.img_url.length>4){
            return {...el,img_url:SERVER_HOSTNAME+el.img_url}
          }
          return el
          
        })
        this.totalPages=data.pages;
      })       
      .catch(err => {
        alert(err.message)
      })
    },
    handleUpdateItem(){
      // console.log('bin selected:',this.bin_selected)
      // if (this.bin_selected) {
      //   this.tempItem.bin = this.bin_selected._id
      // } else {
      //   this.tempItem.bin = null
      // }
      this.tempItem.site = this.siteId

      if (this.$refs.updateItemForm.reportValidity()) {
        request('put', '/items', {...this.tempItem,change_img:this.changeLogo})
          .then(() => {
            return request('get',  `/items/${this.currentPage}?site=${this.siteId}`)
            
          })
          .then(data=>{
            // console.log(this.items)
            this.items = data.items.map(el=>{
              if(el.img_url&&el.img_url.length>4){
                return {...el,img_url:SERVER_HOSTNAME+el.img_url}
              }
              return el
          
            })
            this.totalPages=data.pages;
            this.update_active = false
            this.changeLogo=false
          })
          .catch(err => {
            console.log(err)
            alert(err.message)
          })
      }
    },
    handleAddItem(){
      // if (this.bin_selected) {
      //   this.tempItem.bin = this.bin_selected._id
      // }
      
      this.tempItem.site = this.siteId

      if (this.$refs.addItemForm.reportValidity()) {
        request('post', '/items', this.tempItem)
        .then(() => {
          return request('get',  `/items/${this.currentPage}?site=${this.siteId}`)
          
        })
        .then(data => {
          this.add_active = false
          this.items = data.items.map(el=>{
            if(el.img_url&&el.img_url.length>4){
              return {...el,img_url:SERVER_HOSTNAME+el.img_url}
            }
            return el
          
          })
          this.totalPages=data.pages;
          this.changeLogo=false
        }) 
        .catch(err => {
          console.log(err)
          alert(err.message)
        })
      }
    },
    selectBin(el){
      this.bin_selected=el;
      // this.bin_selected.name= el.name+' of shelf ' +el.shelf.name 
      
      this.list_bin_show=false;
    }
  },
}
</script>
<style lang="scss">
.Item__btn_container{
  display:flex;
  flex-direction:row;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}
.search_item{
  position: relative;
  flex-direction: row;
  input{
    color: black;
    font-size: 1rem;
    height: 48px;
    width: 400px;
    background-color:white;
    border-width: 0px;
    border-radius: 2px;
    padding: 8px;
    padding-right: 40px;
    outline: none;
    margin-top:6px;
  }
  input:hover,:focus{
    border:1px solid #0080F6 !important ;
  }
  svg{
    position: absolute;
    right: 0px;
    top:17px;
    z-index: 2;
  }
}
</style>